/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

export const initialEdmOperatorConnectionTranslation = {
    connectOperator: '',
    postAndEdmNotAvailable: '',
    inquiry: '',
    wayNotAvailable: '',
    needToConnect: '',
    waitForConnection: '',
    useEdm: '',
    edmInfoTooltipTitle: '',
    edmInfoMessage: '',
    start: {
        fields: {
            operator: {
                label: '',
                placeholder: '',
                prompt: '',
            },
            name: {
                label: '',
                placeholder: '',
                prompt: '',
            },
            phone: {
                label: '',
                placeholder: '',
                prompt: '',
            },
            email: {
                label: '',
                placeholder: '',
                prompt: '',
            },
        },
        responsibleContact: '',
        responsibleContactTooltip: '',
        selectOperatorTitle: '',
        createBtnValidation: '',
        changeOperatorTooltipTitle: '',
        cancelConnectionTitle: '',
        cancelConnectionText: '',
        cancelConnectionButton: '',
        connectButton: '',
        editButton: '',
        editButtonTooltipTitle: '',
    },
    success: {
        addConnectionTitle: '',
        messageConnection: '',
        cancelConnectionTitle: '',
    },
    failure: {
        addConnectionTitle: '',
        cancelConnectionTitle: '',
        editResponsibleTitle: '',
        error: {
            codes: {},
        },
    },
    connectionStatus: {
        status: '',
        statusConnectionInProgress: '',
        statusConnected: '',
        statusDisconnectInProgress: '',
        statusDataConnected: '',
        statusData: '',
        responsible: '',
        responsibleAbsent: '',
        changeOperatorButton: '',
        editResponsibleButton: '',
        cancelButton: '',
        deadlineNotification: '',
        inquiry: '',
        inquiryError: '',
    },
};
